/**
 * 날짜 필터 관련 상수
 * @description cure, injection 페이지에서 공통 사용
 * @module constants/dayFilter
 */

/**
 * 지원하는 날짜 필터 옵션
 * @readonly
 */
export const DAY_FILTER_OPTIONS = {
    THREE_DAYS: 3,
    SEVEN_DAYS: 7
};

/**
 * 기본값 (담당자 여부에 따라)
 * @readonly
 */
export const DAY_FILTER_DEFAULTS = {
    MANAGER: 7,      // 담당자: 7일
    NON_MANAGER: 7   // 비담당자: 7일 (3일 필터 제거로 통일)
};

/**
 * 날짜 필터 버튼 설정
 * @type {Array<{value: number, label: string}>}
 */
export const DAY_FILTER_BUTTONS = [
    { value: 3, label: '3일' },
    { value: 7, label: '7일' }
];

/**
 * 날짜 필터 옵션 라벨 반환
 * @param {number} days - 일수
 * @returns {string} 라벨
 */
export function getDayFilterLabel(days) {
    const option = DAY_FILTER_BUTTONS.find(b => b.value === days);
    return option ? option.label : `${days}일`;
}
